export const selectTitleByTag = tagAlias => {
    let title = 'Новости и статьи Дом.ру';

    switch (tagAlias) {
        case 'kinopremera':
            title = 'Кинопремьера';
            break;
        case 'planovo-profilakticheskie-raboty':
            title = 'Планово-профилактические работы';
            break;
        case 'telefoniya':
            title = 'Телефония';
            break;
        case 'tarify':
            title = 'Тарифы';
            break;
        case 'rezhim-raboty':
            title = 'Режим работы';
            break;
        case 'stati':
            title = 'Статьи';
            break;
        case 'internet':
            title = 'Интернет';
            break;
        case 'aktsii':
            title = 'Акции';
            break;
        case 'tekhnologii-i-innovatsii':
            title = 'Технологии и инновации';
            break;
        case 'televidenie':
            title = 'Телевидение';
            break;
        case 'konkursy':
            title = 'Конкурсы';
            break;
        case 'sobytie':
            title = 'Событие';
            break;
        case 'rabota-iz-doma':
            title = 'Работа из дома';
            break;
        case 'mneniya':
            title = 'Мнения';
            break;
        case 'noch-muzeev-2020':
            title = 'Ночь музеев 2020';
            break;
        case 'novoe-na-sayte':
            title = 'Новое на сайте';
            break;
    }
    return title;
};
